module.exports = __webpack_public_path__ + "img/vip-img7-2.25935f4a.png";